import { render, staticRenderFns } from "./PaymentClickableListItem.vue?vue&type=template&id=3491fae5&scoped=true&"
import script from "./PaymentClickableListItem.vue?vue&type=script&lang=js&"
export * from "./PaymentClickableListItem.vue?vue&type=script&lang=js&"
import style0 from "./PaymentClickableListItem.vue?vue&type=style&index=0&id=3491fae5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3491fae5",
  null
  
)

export default component.exports